/** Presentation and new input normalization only; the server owns financial calculations. */
export function ceilWonAmount(value: number): number {
  // Round the magnitude up and retain the sign for signed presentation amounts.
  const amount = value < 0 ? -Math.ceil(Math.abs(value)) : Math.ceil(value);
  // Canonicalize zero to avoid displaying a negative zero currency.
  return Object.is(amount, -0) ? 0 : amount;
}

export function formatWonNumber(value: number | null | undefined): string {
  return ceilWonAmount(value ?? 0).toLocaleString("ko-KR");
}

export function formatWonAmount(value: number | null | undefined): string {
  return `${formatWonNumber(value)}원`;
}
